import React, { useState, useContext } from "react";
import { Box, Button, useMediaQuery, Typography } from "@mui/material";
import { constants } from "ethers";
import { parseUnits } from "@ethersproject/units";
import { toast } from "react-toastify";
import { AiOutlinePlus } from "react-icons/ai";
import { BiDownArrowAlt } from "react-icons/bi";

import { useStakingContract, useTokenContract } from "../ConnectivityAss/hooks";
import { stakingAddress } from "../ConnectivityAss/environment";
import { AppContext, gasEstimationForAll } from "../utils";

export default function Pool1({ apr, init, setloading }) {
  const matches = useMediaQuery("(max-width:750px)");

  const { account, signer } = useContext(AppContext);

  const stakingContract = useStakingContract(signer);
  const tokenContract = useTokenContract(signer);

  const [stakingAmount, setstakingAmount] = useState("");
  const [stakingAmount1, setstakingAmount1] = useState("");

  const getStakeReward = (e) => {
    const event = +e.target.value;
    setstakingAmount(event);
    const newValue = event + (event * +apr) / 100;
    setstakingAmount1(newValue);
  };

  const stakeHandler = async () => {
    if (!account) {
      toast.error("Error! Please connect your wallet.");
    } else if (!stakingAmount) {
      toast.error("Error! Please enter amount.");
    } else if (isNaN(+stakingAmount) || +stakingAmount < 0) {
      toast.error("Error! Please enter valid amount.");
    } else {
      try {
        setloading(true);
        const dec = await tokenContract.decimals();
        const allowance = await tokenContract.allowance(
          account,
          stakingAddress
        );

        if (+allowance < +stakingAmount) {
          const tx = await tokenContract.approve(
            stakingAddress,
            constants.MaxUint256
          );
          await tx.wait();
        }
        const data = [parseUnits(stakingAmount.toString(), +dec).toString()];
        const fn = stakingContract.estimateGas.stake;

        const tx1 = await stakingContract.stake(
          parseUnits(stakingAmount.toString(), +dec).toString(),
          {
            gasLimit: gasEstimationForAll(account, fn, data),
          }
        );
        await tx1.wait();
        toast.success("Success! Transaction Confirmed.");
        init();
        setloading(false);
      } catch (err) {
        if (err?.data?.message) {
          toast.error(err?.data?.message);
        } else {
          toast.error(err?.message);
        }
        setloading(false);
      }
    }
  };

  return (
    <Box
      display="flex"
      border="0.764763px solid #6F64FF"
      bgcolor="rgba(100, 73, 215, 0.1)"
      justifyContent="center"
      sx={{
        backdropFilter: "blur(12.2362px)",
        clipPath:
          "polygon(100% 0%, 87% 0%, 100% 30%, 100% 100%, 82% 100%, 0px 100%, 0px 100%, 0% 0%)",
      }}
    >
      <Box
        position="relative"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        maxWidth="775px"
        p={5}
      >
        <Box
          textAlign="center"
          fontFamily="Poppins"
          fontWeight={400}
          fontSize="12.24px"
        >
          Calculate your Solar Earnings based on 12 months
        </Box>
        <Box
          display="flex"
          justifyContent="space-evenly"
          bgcolor="rgba(100, 73, 215, 0.1)"
          border="0.764763px solid rgba(111, 100, 255, 0.45)"
          p={2}
          width="70%"
          alignItems="center"
          mt={4}
        >
          <Box
            fontFamily="Poppins"
            fontSize={{ xs: "12px", sm: "13px" }}
            fontWeight={700}
          >
            Solar Shepard
          </Box>
          <input
            type="number"
            min={0}
            placeholder="0"
            style={{
              height: "32.88px",
              textAlign: "center",
              width: "50%",
            }}
            value={stakingAmount}
            onChange={(e) => getStakeReward(e)}
          />
        </Box>
        <Box textAlign="center">
          <AiOutlinePlus color="#fff" fontSize="25px" fontWeight={500} />
        </Box>
        <Box mt={3} fontSize="12px" textAlign="center">
          Locked At {apr}% APR
        </Box>
        <Box mb={3} fontSize="12px" textAlign="center">
          For 90 days
        </Box>

        <Box textAlign="center" my={1}>
          <BiDownArrowAlt color="#fff" fontSize="25px" fontWeight={500} />
        </Box>
        <Box
          display="flex"
          justifyContent="space-evenly"
          bgcolor="rgba(100, 73, 215, 0.1)"
          border="0.764763px solid rgba(111, 100, 255, 0.45)"
          p={2}
          width="70%"
          alignItems="center"
          mb={4}
        >
          <Box
            fontFamily="Poppins"
            fontSize={{ xs: "12px", sm: "13px" }}
            fontWeight={700}
          >
            Solar Shepard
          </Box>
          <input
            type="number"
            min={0}
            readOnly
            placeholder="0"
            style={{
              height: "32.88px",
              textAlign: "center",
              width: "50%",
            }}
            value={stakingAmount1}
          />
        </Box>

        {account ? (
          <>
            <Button
              variant="gradient"
              sx={{
                borderRadius: "43.59px",
                color: "#fff",
                fontFamily: "Poppins",
                fontWeight: 700,
                fontSize: matches ? "12px" : "20px",
                textTransform: "capitalize",
                width: "70%",
                height: "40px",
                cursor: "pointer",
              }}
              onClick={stakeHandler}
            >
              Stake
            </Button>
          </>
        ) : (
          <Button
            variant="gradient"
            sx={{
              borderRadius: "43.59px",
              color: "#fff",
              fontFamily: "Poppins",
              fontWeight: 700,
              fontSize: matches ? "12px" : "20px",
              textTransform: "capitalize",
              width: "70%",
              height: "40px",
              cursor: "pointer",
            }}
            onClick={() => toast.error("Please connect your wallet.")}
          >
            Connect Wallet
          </Button>
        )}
      </Box>
    </Box>
  );
}
